import React, {useState, useEffect, useRef} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Sidebar} from "primereact/sidebar";
import {addLocale} from "primereact/api";
import {Button} from "primereact/button";
import {Calendar} from "primereact/calendar";
import {Dropdown} from "primereact/dropdown";
import {Tooltip} from 'primereact/tooltip';
import {ProgressBar} from 'primereact/progressbar';
import {Dialog} from "primereact/dialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {Message} from "primereact/message";
import moment from "moment";
import axios from "axios";
import Cookies from "js-cookie";
import FullCalendar from '@fullcalendar/react'

import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import allLocales from '@fullcalendar/core/locales-all'
import interactionPlugin from '@fullcalendar/interaction'

import HelpComponent from "../components/HelpComponent";
import _FM_ReservationFormComponent from "../components/_FM_reservation/_FM_ReservationFormComponent";
import _FM_ReservationResourceFormComponent from "../components/_FM_reservation/_FM_ReservationResourceFormComponent";
import _FM_ReservationShowComponent from "../components/_FM_reservation/_FM_ReservationShowComponent";
import _FM_FolioShowComponent from "../components/_FM_folio/_FM_FolioShowComponent";
import _FM_FolioFormComponent from "../components/_FM_folio/_FM_FolioFormComponent";
import _FM_FolioDndComponent from "../components/_FM_folio/_FM_FolioDndComponent";
import _FM_ReceiptFormComponent from "../components/_FM_receipt/_FM_ReceiptFormComponent";
import _FM_ReceiptShowComponent from "../components/_FM_receipt/_FM_ReceiptShowComponent";
import _FM_ReservationRelocateFormComponent from "../components/_FM_reservation/_FM_ReservationRelocateFormComponent";

const _FM_CalendarPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {action, id} = useParams();
  const [selectedDate, setSelectedDate] = useState(() => {
    const storedDate = localStorage.getItem('selectedDate');
    if (storedDate && storedDate !== 'undefined') {
      return moment(storedDate).toDate();
    }
    return moment().subtract(0, 'days').toDate();
  });
  const [accommodations, setAccommodations] = useState([])
  const [categories, setCategories] = useState([])
  const [units, setUnits] = useState([])
  const [reservations, setReservations] = useState([])
  const [days, setDays] = useState([])
  const [resources, setResources] = useState([])
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(false)
  const [isEventClicked, setIsEventClicked] = useState(false)
  const [screenSize, setScreenSize] = useState(getScreenSize());
  const calendarRef = useRef(null);
  const lastMouseUpEventRef = useRef(null);
  const inFlightRequestsRef = useRef(new Map());
  const [event, setEvent] = useState()
  const [lastDroppedId, setLastDroppedId] = useState()

  const formatSortPrefix = (sortValue) => {
    const n = Number(sortValue);
    if (Number.isFinite(n)) {
      return String(n).padStart(4, '0');
    }
    return String(sortValue ?? '0');
  };
  const buildUnitResourceId = (sortValue, parts) => {
    return `${formatSortPrefix(sortValue)}-U-${parts.join('-')}`;
  };
  const stripUnitSortPrefix = (resourceId) => {
    if (typeof resourceId !== 'string') return resourceId;
    return resourceId.replace(/^[^-]+-(?=U-)/, '');
  };
  const getUnitIdFromResourceId = (resourceId) => {
    const normalized = stripUnitSortPrefix(resourceId);
    if (!normalized) return null;
    const parts = normalized.split('-');
    return Number(parts[parts.length - 1]);
  };
  const CleaningBroomIcon = ({className, style, onClick}) => (
    <svg
      viewBox="0 0 50 50"
      aria-hidden="true"
      focusable="false"
      className={className}
      style={{width: "1em", height: "1em", ...style}}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="currentColor">
        <path
          d="M46.4375 0.03125C45.539063 0.0390625 44.695313 0.398438 44.21875 1.125L36.625 15.40625C37.1875 15.601563 38.453125 16.164063 42.65625 18.0625L42.71875 18.09375C43.445313 18.421875 44 18.65625 44.21875 18.75C44.292969 18.785156 44.363281 18.839844 44.4375 18.875L49.96875 3.5625C50.316406 2.351563 49.449219 0.957031 48.0625 0.40625C47.546875 0.148438 46.976563 0.0273438 46.4375 0.03125 Z M 4 8C1.792969 8 0 9.792969 0 12C0 14.207031 1.792969 16 4 16C6.207031 16 8 14.207031 8 12C8 9.792969 6.207031 8 4 8 Z M 13 11C11.894531 11 11 11.894531 11 13C11 14.105469 11.894531 15 13 15C14.105469 15 15 14.105469 15 13C15 11.894531 14.105469 11 13 11 Z M 32.15625 16.625C30.222656 16.769531 28.539063 17.730469 27.34375 19.40625C28.097656 20.675781 29.417969 22.226563 31.28125 22.1875C31.773438 22.167969 32.1875 22.523438 32.28125 23C32.660156 23.589844 34.988281 24.636719 35.65625 24.375C35.9375 24.265625 36.238281 24.289063 36.5 24.4375C36.761719 24.585938 36.949219 24.828125 37 25.125C37.039063 25.289063 37.476563 25.863281 38.375 26.28125C39.082031 26.609375 39.769531 26.691406 40.15625 26.5C40.40625 26.375 40.679688 26.371094 40.9375 26.46875C41.199219 26.566406 41.425781 26.773438 41.53125 27.03125C42.207031 28.679688 45.292969 28.800781 47.40625 28.625C47.714844 27.285156 47.632813 25.890625 47.15625 24.59375C46.496094 22.808594 45.1875 21.398438 43.40625 20.59375C43.21875 20.511719 42.613281 20.222656 41.84375 19.875C38.28125 18.265625 36.269531 17.390625 35.875 17.28125C34.570313 16.765625 33.316406 16.539063 32.15625 16.625 Z M 11.5 18C8.46875 18 6 20.46875 6 23.5C6 26.53125 8.46875 29 11.5 29C14.53125 29 17 26.53125 17 23.5C17 20.46875 14.53125 18 11.5 18 Z M 26.28125 21.40625C25.96875 22.148438 25.613281 22.84375 25.25 23.5C25.679688 24.546875 26.949219 26.972656 29.28125 26.4375C29.550781 26.375 29.835938 26.410156 30.0625 26.5625C30.292969 26.714844 30.421875 26.949219 30.46875 27.21875C30.535156 27.59375 30.976563 28.039063 31.59375 28.375C32.46875 28.847656 33.414063 28.953125 33.8125 28.78125C34.074219 28.667969 34.367188 28.660156 34.625 28.78125C34.882813 28.902344 35.078125 29.132813 35.15625 29.40625C35.296875 29.882813 35.789063 30.371094 36.46875 30.71875C37.269531 31.125 38.183594 31.273438 38.78125 31.0625C39.242188 30.902344 39.734375 31.097656 39.96875 31.53125C40.851563 33.167969 43.75 33.34375 46 33.1875C46.285156 32.375 46.550781 31.539063 46.8125 30.65625C46.542969 30.671875 46.261719 30.6875 45.96875 30.6875C43.875 30.6875 41.371094 30.273438 40.125 28.5625C39.28125 28.675781 38.3125 28.492188 37.34375 28C36.640625 27.640625 35.867188 27.089844 35.40625 26.40625C34.132813 26.40625 32.667969 25.699219 31.9375 25.25C31.371094 24.902344 30.929688 24.558594 30.65625 24.1875C28.671875 24.003906 27.253906 22.710938 26.28125 21.40625 Z M 24 25.46875C17.800781 34.082031 7.214844 33.828125 7.09375 33.8125C6.699219 33.777344 6.3125 33.988281 6.125 34.34375C5.9375 34.699219 5.964844 35.125 6.21875 35.4375C8.003906 37.640625 9.921875 39.503906 11.875 41.09375C12.796875 41.277344 18.597656 42.097656 24.34375 35.4375C24.703125 35.019531 25.332031 34.984375 25.75 35.34375C26.167969 35.703125 26.203125 36.332031 25.84375 36.75C21.835938 41.394531 17.609375 42.847656 14.65625 43.15625C17.125 44.820313 19.613281 46.078125 21.9375 47.03125C23.414063 46.722656 28.367188 45.242188 32.75 38.5625C33.054688 38.101563 33.695313 37.945313 34.15625 38.25C34.617188 38.554688 34.742188 39.195313 34.4375 39.65625C31.132813 44.691406 27.515625 47.054688 24.96875 48.15625C30.167969 49.839844 34.046875 49.988281 34.375 50L34.40625 50C34.59375 50 34.777344 49.945313 34.9375 49.84375C35.21875 49.667969 41.007813 45.886719 45.25 35.25C45.085938 35.253906 44.917969 35.28125 44.75 35.28125C42.5625 35.28125 40.035156 34.839844 38.65625 33.125C37.6875 33.242188 36.578125 33.019531 35.5625 32.5C34.734375 32.074219 34.078125 31.503906 33.65625 30.84375C32.59375 30.933594 31.445313 30.550781 30.65625 30.125C29.84375 29.683594 29.207031 29.128906 28.84375 28.5C26.542969 28.621094 24.945313 27.054688 24 25.46875Z"/>
      </g>
    </svg>
  );

  function getScreenSize() {
    const width = window.innerWidth;
    if (width < 768) return "small";
    if (width >= 768 && width < 1440) return "medium";
    return "large";
  }

  const apiCall = (method, url, data) => {
    const normalizedMethod = String(method || '').toLowerCase();
    const requestKey = normalizedMethod === 'get'
      ? `${normalizedMethod}:${url}`
      : null;

    if (normalizedMethod === 'get') {
      const inFlightRequest = inFlightRequestsRef.current.get(requestKey);
      if (inFlightRequest) {
        return inFlightRequest;
      }
    }

    const request = axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    });

    if (normalizedMethod === 'get') {
      inFlightRequestsRef.current.set(requestKey, request);
      request.finally(() => {
        inFlightRequestsRef.current.delete(requestKey);
      });
    }

    return request;
  }

  addLocale('default', {
    firstDayOfWeek: 1,
    dayNames: [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday'), t('saturday')],
    dayNamesShort: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    dayNamesMin: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    monthNames: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    monthNamesShort: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    today: t('today'),
    clear: t('delete')
  });

  const patchEvent = (info) => {
    setLoading(true)
    let _targetResource = {}
    if (info.newResource) {
      if (info?.newResource?._resource?.extendedProps?.level === 2 && info?.newResource?._resource?.id.includes('U-')) {
        //alert('első szintű unitra lett húzva')
        _targetResource = {
          berth: null,
          residential_unit: info?.newResource?._resource?.extendedProps?.originalId
        }
      } else if (info?.newResource?._resource?.extendedProps?.level === 3 && info?.newResource?._resource?.id?.includes('B-')) {
        //alert('második szintű ágyra lett húzva')
        _targetResource = {
          berth: info?.newResource?._resource?.extendedProps?.originalId,
          residential_unit: getUnitIdFromResourceId(info?.newResource?._resource?.parentId)
        }
      } else if (info?.newResource?._resource?.extendedProps?.level === 3 && info?.newResource?._resource?.id?.includes('U-')) {
        //alert('második szintű unitra lett húzva')
        _targetResource = {
          berth: null,
          residential_unit: info?.newResource?._resource?.extendedProps?.originalId
        }
      } else if (info?.newResource?._resource?.extendedProps?.level === 4 && info?.newResource?._resource?.id?.includes('B-')) {
        //alert('harmadik szintű ágyra lett húzva')
        _targetResource = {
          berth: info?.newResource?._resource?.extendedProps?.originalId,
          residential_unit: getUnitIdFromResourceId(info?.newResource?._resource?.parentId)
        }
      }
    }
    apiCall('patch', 'reservation/' + info?.event?.title,
      {
        reserved_from: info.event.start,
        reserved_to: info.event.end,
        ..._targetResource,
      })
      .then(response => {
        let dateFrom = moment(selectedDate).add(-1, "days").format("YYYY-MM-DD");
        let dateTo = moment(selectedDate).add(22, "days").format("YYYY-MM-DD");
        buildCalendar(dateFrom, dateTo);
        window.App.setState({confirmCalendarDnd: false})
      })
      .catch(error => {
        setLastDroppedId(null)
        let dateFrom = moment(selectedDate).add(-1, "days").format("YYYY-MM-DD");
        let dateTo = moment(selectedDate).add(22, "days").format("YYYY-MM-DD");
        buildCalendar(dateFrom, dateTo);
        window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        window.App.setState({confirmCalendarDnd: false})
      })
  }

  const buildCalendar = async (dateFrom, dateTo) => {
    setLoading(true)
    try {
      const _accommodationsResponse = await apiCall('get', 'accommodation')
      const accommodationItems = _accommodationsResponse?.data?.data?.items || [];
      setAccommodations(accommodationItems)
      const selectedAccommodationId = localStorage.getItem('selectedAccommodation')
        || accommodationItems?.[0]?.id;
      if (selectedAccommodationId && selectedAccommodationId !== 'undefined') {
        if (!localStorage.getItem('selectedAccommodation') || localStorage.getItem('selectedAccommodation') === 'undefined') {
          localStorage.setItem('selectedAccommodation', selectedAccommodationId)
        }
        // get categories by accommodation
        const categories_ = await apiCall('get', 'residential-category?search[accommodation]='
          + selectedAccommodationId)
        let _categories = []
        categories_.data.data.items.map((cat, index) => {
          _categories.push({
            id: cat.id,
            label: cat.name,
            type: 'category',
            eventCreation: false,
            originalId: cat.id,
            level: 1,
          })
        })
        if (!categories_.data.data.items[0]) {
          window.App.toastShow('warn', t('warning'), t('no_category_found'));
          setResources([])
          setEvents([])
          setLastDroppedId(null)
          setLoading(false)
          return false
        }
        setCategories(_categories)

        // get units
        const units_ = await apiCall('get', 'residential-unit/tree?search[accommodation]=' + selectedAccommodationId)
        let _units = []
        const unitResourceIdByOriginalId = new Map();
        units_.data.map((unit, index) => {
          let _children = []
          if (unit.children && unit.children[0]) {
            unit.children.map((child, index) => {
              const childId = buildUnitResourceId(child.sort, [child.residential_category.id, unit.id, child.id]);
              unitResourceIdByOriginalId.set(child.id, childId);
              _children.push({
                id: childId,
                label: child.name,
                type: 'unit',
                eventCreation: false,
                parentId: buildUnitResourceId(unit.sort, [unit.residential_category.id, unit.id]),
                originalId: child.id,
                level: 3,
                children: child.berths,
                berths: child.berths.length,
                is_ready: child.is_ready,
                clean: child.clean,
              })
            })
          }
          const unitId = buildUnitResourceId(unit.sort, [unit.residential_category.id, unit.id]);
          unitResourceIdByOriginalId.set(unit.id, unitId);
          _units.push({
            id: unitId,
            label: unit.name,
            type: 'unit',
            eventCreation: false,
            parentId: unit.residential_category.id,
            originalId: unit.id,
            level: 2,
            children: _children,
            berths: unit.berths.length,
            is_ready: unit.is_ready,
            clean: unit.clean,
          })
        })
        if (!units_.data[0]) {
          window.App.toastShow('warn', t('warning'), t('no_unit_found'));
          setLastDroppedId(null)
          setLoading(false)
          return false
        }
        setUnits(_units)

        // get beds
        const beds_ = await apiCall('get', 'berth?search[accommodation]=' + selectedAccommodationId)
        let _beds = []
        beds_.data.data.items.map((bed, index) => {
          const unitParentId = unitResourceIdByOriginalId.get(bed.residential_unit.id)
            ?? ("U-" + bed.residential_unit.residential_category.id + "-" + bed.residential_unit.id);
          _beds.push({
            id: "B-" + bed.residential_unit.residential_category.id + "-" + bed.residential_unit.id + "-" + bed.id,
            label: bed.name,
            type: 'bed',
            eventCreation: false,
            parentId: unitParentId,
            originalId: bed.id,
            level: 3,
          })
        })

        let categories = _categories
        let units = _units
        let beds = _beds

        // build calendar data
        if (units[0] && categories[0]) {
          let _nodes = []
          categories.map((category, index) => {
              let _units = units.filter(item => item.parentId === category.originalId)
              let __units = []
              _units.map((unit, index) => {
                let _beds = beds.filter(item => item.parentId === unit.id)
                if (unit.children && unit.children[0]) {
                  unit.children.map((child, index) => {
                    let ___beds = []
                    if (child.children && child.children[0]) {
                      child.children.map((bed, index) => {
                        ___beds.push({
                          id: "B-" + category.originalId + "-" + unit.originalId + "-" + bed.id,
                          label: bed.name,
                          type: 'bed',
                          eventCreation: false,
                          originalId: bed.id,
                          level: 4,
                        })
                      })
                    }
                    child.children = ___beds
                    _beds.push(child)
                  })
                }
                __units.push({
                  ...unit,
                  children: _beds,
                })
              })
              _nodes.push({
                ...category,
                children: __units
              })
            }
          )
          _nodes.push({
              id: 'RNUNB-1',
              label: t('no_unit_reservations'),
              type: 'category',
              eventCreation: false,
              originalId: 'RNUNB-1',
              level: 1,
            },
          )
          setResources(_nodes)
          if (_nodes[0]) {
            // const style = document.createElement('style');
            // style.type = 'text/css';
            // style.innerHTML = `
            //       table.fc-scrollgrid-sync-table tr:has(td[data-resource-id="RNUNB-1"]) {
            //         display: none !important;
            //       }
            //
            //       table.fc-datagrid-body tr:has(td[data-resource-id="RNUNB-1"]) {
            //         display: none !important;
            //       }
            //     `;
            // document.head.appendChild(style);
            //build events
            let _events = []
            const reservationQueryParams = new URLSearchParams();
            reservationQueryParams.set('search[reserved_from][operator]', '<=');
            reservationQueryParams.set('search[reserved_from][value]', `${dateTo} 23:59:59`);
            reservationQueryParams.set('search[reserved_to][operator]', '>=');
            reservationQueryParams.set('search[reserved_to][value]', `${dateFrom} 00:00:00`);
            const _reservations = await apiCall('get', `reservation?${reservationQueryParams.toString()}`);
            setReservations(_reservations.data.data.items)
            for (const reservation of _reservations.data.data.items) {
              let resource
              let hasBeds = 'HB '
              let relocated = ''
              if (reservation.berth === null && reservation.residential_unit === null) {
                resource = 'RNUNB-1'
                // const style = document.createElement('style');
                // style.type = 'text/css';
                // style.innerHTML = `
                //   table.fc-scrollgrid-sync-table tr:has(td[data-resource-id="RNUNB-1"]) {
                //     display: table-row !important;
                //   }
                //
                //   table.fc-datagrid-body tr:has(td[data-resource-id="RNUNB-1"]) {
                //     display: table-row !important;
                //   }
                // `;
                // document.head.appendChild(style);
              } else if (reservation.residential_unit && reservation.berth === null) {
                resource = unitResourceIdByOriginalId.get(reservation?.residential_unit?.id)
                  ?? (reservation?.residential_unit?.parent
                    ? "U-" + reservation?.residential_unit?.residential_category?.id + "-" + reservation?.residential_unit?.parent?.id + "-" + reservation?.residential_unit?.id
                    : "U-" + reservation?.residential_unit?.residential_category?.id + "-" + reservation?.residential_unit?.id)
                if (reservation?.residential_unit?.parent) {
                  let unit = units.filter(item => item.originalId === reservation?.residential_unit?.parent?.id)
                  if (unit && unit[0] && unit[0].children && unit[0].children[0] && unit[0].children[0].berths) {
                    hasBeds = 'hasBeds hasBeds-' + unit[0].children[0].berths
                  }
                } else {
                  let unit = units.filter(item => item.originalId === reservation.residential_unit.id)
                  if (unit && unit[0] && unit[0].berths) {
                    hasBeds = 'hasBeds hasBeds-' + unit[0].berths
                  }
                }
                if (reservation.relocated_to) {
                  relocated = '/B'
                }
                if (reservation.relocated_from) {
                  relocated = '/C'
                }
              } else {
                if (reservation.berth.residential_unit.parent) {
                  resource = "B-" + reservation.berth.residential_unit.residential_category.id + "-" + reservation.berth.residential_unit.parent.id + "-" + reservation.berth.id
                  // szerintem itt kellene a parent uni id is majd
                } else {
                  resource = "B-" + reservation.berth.residential_unit.residential_category.id + "-" + reservation.berth.residential_unit.id + "-" + reservation.berth.id
                }
              }
              let partly = false
              if (moment(reservation.reserved_to).diff(moment(reservation.reserved_from), 'hours') < 12) {
                partly = true
                reservation.reserved_from = moment.utc(reservation.reserved_from).local().startOf('day').format()
                reservation.reserved_to = moment.utc(reservation.reserved_to).local().endOf('day').format()
              } else {
                reservation.reserved_from = moment.utc(reservation.reserved_from).local().format('YYYY-MM-DDT15:00:00')
                reservation.reserved_to = moment.utc(reservation.reserved_to).local().format('YYYY-MM-DDT10:00:00')
              }
              let errors = 0
              if (reservation.errors && reservation.errors[0]) {
                errors = reservation?.errors.length
              }
              let _contact = ''
              if (reservation.contact_name) {
                _contact += reservation.contact_name + ' '
              }
              if (reservation.contact_email) {
                _contact += reservation.contact_email + ' '
              }
              if (reservation.contact_number) {
                _contact += reservation.contact_number + ' '
              }
              let numberOfGuests = reservation?.guests?.filter((guest) => guest?.deleted_at === null)?.length || 0
              if (reservation.deleted_at_snapshot === null &&
                reservation.status !== 'cancelled' && reservation.status !== 'no_show') {
                _events.push({
                  id: reservation.public_id.slice(-6),
                  readableId: reservation.public_id.slice(-6),
                  originalId: reservation.id,
                  start: reservation.reserved_from,
                  end: reservation.reserved_to,
                  title: reservation.id,
                  contact: _contact,
                  guests: '',
                  numberOfGuests: numberOfGuests,
                  status: reservation?.status + ' ' + hasBeds,
                  note: reservation.note,
                  reservationId: "" + reservation.public_id.slice(-6) + relocated,
                  billingStatus: 'unpaid',
                  resourceId: resource,
                  reservation: reservation,
                  errors: errors,
                  tooltip: "" + reservation?.customers?.length || reservation?.number_of_guests || 0,
                  partly: partly,
                  display: 'auto',
                  source: reservation.source,
                  channel: reservation?.channel?.name,
                  overlap: true,
                })
              }
            }

            const oooAccs_ = await apiCall('get',
              'out-of-order-accommodation?search[start_at][operator]=between&search[start_at][value]=' + dateFrom + ',' + dateTo)
            const unitResourcesForOooAccommodation = []
            units.forEach((unit) => {
              const hasBeds = unit.berths ? ('hasBeds hasBeds-' + unit.berths) : 'HB ';
              unitResourcesForOooAccommodation.push({
                categoryId: unit.parentId,
                unitId: unit.originalId,
                resourceId: unit.id,
                hasBeds,
              })
              if (unit.children && unit.children[0]) {
                unit.children.forEach((childUnit) => {
                  if (childUnit.type === 'unit') {
                    const childHasBeds = childUnit.berths ? ('hasBeds hasBeds-' + childUnit.berths) : 'HB ';
                    unitResourcesForOooAccommodation.push({
                      categoryId: unit.parentId,
                      unitId: childUnit.originalId,
                      resourceId: childUnit.id,
                      hasBeds: childHasBeds,
                    })
                  }
                })
              }
            })
            oooAccs_.data.data.items.map((item, index) => {
              unitResourcesForOooAccommodation.forEach((unitResource) => {
                _events.push({
                  id: unitResource.categoryId + "-" + unitResource.unitId,
                  readableId: '',
                  originalId: item.id,
                  start: item.start_at,
                  end: item.end_at,
                  title: t('oooAccommodation'),
                  contact: '',
                  guests: '',
                  status: 'ooo' + ' ' + unitResource.hasBeds,
                  note: '',
                  reservationId: '',
                  billingStatus: 'unpaid',
                  resourceId: unitResource.resourceId,
                  reservation: {},
                  errors: '',
                  tooltip: false,
                  partly: '',
                  display: 'background',
                  source: '',
                  channel: '',
                  overlap: true,
                  background: true
                })
              })
            })

            const oooBerths_ = await apiCall('get',
              'out-of-order-berth?search[start_at][operator]=between&search[start_at][value]=' + dateFrom + ',' + dateTo)
            oooBerths_.data.data.items.map((item, index) => {
              _events.push({
                id: item.id,
                readableId: '',
                originalId: item.id,
                start: item.start_at,
                end: item.end_at,
                title: t('ooo'),
                contact: '',
                guests: '',
                status: 'ooo',
                note: '',
                reservationId: '',
                billingStatus: 'unpaid',
                resourceId: "B-"
                  + item?.berth?.residential_unit?.residential_category?.id
                  + "-"
                  + (item?.berth?.residential_unit?.parent?.id ?? item?.berth?.residential_unit?.id)
                  + "-"
                  + item?.berth?.id,
                reservation: {},
                errors: '',
                tooltip: false,
                partly: '',
                display: 'background',
                source: '',
                channel: '',
                overlap: true,
                background: true
              })
            })
            const oooUnits_ = await apiCall('get',
              'out-of-order-residential-unit?search[start_at][operator]=between&search[start_at][value]=' + dateFrom + ',' + dateTo)
            oooUnits_.data.data.items.map((item, index) => {
              let hasBeds = 'HB '
              if (item.residential_unit.parent) {
                let unit = units.filter(item_ => item_.originalId === item.residential_unit.parent.id)
                if (unit && unit[0] && unit[0].children && unit[0].children[0] && unit[0].children[0].berths) {
                  hasBeds = 'hasBeds hasBeds-' + unit[0].children[0].berths
                }
              } else {
                let unit = units.filter(item_ => item_.originalId === item.residential_unit.id)
                if (unit && unit[0] && unit[0].berths) {
                  hasBeds = 'hasBeds hasBeds-' + unit[0].berths
                }
              }
              _events.push({
                id: item.id,
                readableId: '',
                originalId: item.id,
                start: item.start_at,
                end: item.end_at,
                title: t('ooo'),
                contact: '',
                guests: '',
                status: 'ooo' + ' ' + hasBeds,
                note: '',
                reservationId: '',
                billingStatus: 'unpaid',
                resourceId: unitResourceIdByOriginalId.get(item.residential_unit.id)
                  ?? ("U-" + item.residential_unit.residential_category.id + "-" + item.residential_unit.id),
                reservation: {},
                errors: '',
                tooltip: false,
                partly: '',
                display: 'background',
                source: '',
                channel: '',
                overlap: true,
                background: true
              })
            })
            setEvents(_events)
            setLastDroppedId(null)
            setLoading(false)

            // foglaltság jelzés
            let inclusive = true, format = "YYYY-MM-DD"
            let start = moment(dateFrom).startOf("day");
            let end = moment(dateTo).startOf("day");
            if (end.isBefore(start)) [start, end] = [end, start];
            const last = inclusive ? end : end.clone().subtract(1, "day");
            const days = [];
            for (const d = start.clone(); d.isSameOrBefore(last, "day"); d.add(1, "day")) {
              days.push(d.format(format));
            }
            setDays(days)
          }
        }
      } else {
        setLoading(false)
        window.App.toastShow('warn', t('warning'), t('no_accommodation_found'));
      }
    } catch
      (error) {
      setLoading(false)
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    }
  };

  useEffect(() => {
    document.title = t('calendar') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/calendar')
  }, [t]);

  // useEffect(() => {
  //   if (action === 'create' || action === 'update') {
  //     window.App.help('/reservation')
  //   }
  // }, [action]);

  useEffect(() => {
    let dateFrom = moment(selectedDate).add(-1, "days").format("YYYY-MM-DD");
    let dateTo = moment(selectedDate).add(22, "days").format("YYYY-MM-DD");
    if (screenSize === "small") {
      dateTo = moment(selectedDate).add(4, "days").format("YYYY-MM-DD");
    }
    if (screenSize === "medium") {
      dateTo = moment(selectedDate).add(10, "days").format("YYYY-MM-DD");
    }
    if (calendarRef.current) {
      if (localStorage.getItem('selectedDate')) {
        calendarRef.current.getApi().gotoDate(moment(localStorage.getItem('selectedDate')).format('YYYY-MM-DD'));
        dateFrom = moment(localStorage.getItem('selectedDate')).format("YYYY-MM-DD");
        dateTo = moment(localStorage.getItem('selectedDate')).add(22, "days").format("YYYY-MM-DD");
        if (screenSize === "small") {
          dateTo = moment(localStorage.getItem('selectedDate')).add(4, "days").format("YYYY-MM-DD");
        }
        if (screenSize === "medium") {
          dateTo = moment(localStorage.getItem('selectedDate')).add(10, "days").format("YYYY-MM-DD");
        }
      } else {
        calendarRef.current.getApi().gotoDate(moment(selectedDate).format('YYYY-MM-DD'));
      }
    }
    buildCalendar(dateFrom, dateTo);
  }, [selectedDate, window.App.state.rerenderReservationList, window.App.state.rerenderOoounitList, window.App.state.rerenderOooberthList]);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(getScreenSize());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleMouseUp = (event) => {
      lastMouseUpEventRef.current = event;
    };

    window.addEventListener("mouseup", handleMouseUp, true);
    return () => window.removeEventListener("mouseup", handleMouseUp, true);
  }, []);

  useEffect(() => {
    if (categories && categories[0] && units && units[0] && reservations && reservations[0] && days && days[0]) {
      let _events = []
      categories.map((category, index) => {
        Object.entries(days).map((day, dayIndex) => {
          let countedUnits = units.filter(item => item.parentId === category.id).length

          const dayStartMs = (yyyyMmDd) => new Date(`${yyyyMmDd}T00:00:00`).getTime();
          const isoToDayStartMs = (isoDateTime) => {
            // "2026-02-08T10:00:00" -> "2026-02-08"
            const d = String(isoDateTime || "").slice(0, 10);
            return d ? dayStartMs(d) : NaN;
          };
          const isDayWithinReservation = (reservation, day) => {
            const dayMs = dayStartMs(day);
            const fromMs = isoToDayStartMs(reservation?.reserved_from);
            const toMs = isoToDayStartMs(reservation?.reserved_to);
            if (!Number.isFinite(dayMs) || !Number.isFinite(fromMs) || !Number.isFinite(toMs)) return false;
            // [from, to) nap-alapon
            return fromMs <= dayMs && dayMs < toMs;
          };
          const countReservationsInCategoryOnDay = (reservations, categoryId, day) => {
            const targetCatId = Number(categoryId);
            return reservations.reduce((acc, r) => {
              const catId = r?.residential_unit?.residential_category?.id;
              if (Number(catId) !== targetCatId) return acc;
              if (r?.status === 'cancelled' || r?.status === 'no_show') return acc;
              return acc + (isDayWithinReservation(r, day) ? 1 : 0);
            }, 0);
          };
          const countedReservations = countReservationsInCategoryOnDay(reservations, category.id, day[1]);

          const occEventId = "occ-" + category.id + "-" + dayIndex;
          _events.push({
            id: occEventId,
            readableId: '',
            originalId: occEventId,
            start: day[1],
            end: day[1],
            title: countedUnits + "/" + (countedUnits - countedReservations),
            contact: '',
            guests: '',
            status: 'occ',
            note: '',
            reservationId: '',
            billingStatus: '',
            resourceId: category.id,
            reservation: {},
            errors: '',
            tooltip: false,
            partly: '',
            display: 'auto',
            source: '',
            channel: '',
            overlap: true,
            background: true
          })

        })
      })
      setEvents((prevEvents) => {
        const nonOccEvents = prevEvents.filter((e) => e.status !== 'occ');
        return [...nonOccEvents, ..._events];
      })
    }
  }, [categories, units, reservations, days]);

  return (
    <>
      {loading &&
        <ProgressBar mode="indeterminate" style={{height: '5px'}}></ProgressBar>
      }
      <div className="_FM_CalendarPage p-component p-my-lg-4 p-mx-lg-1">
        <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/calendar"}/>
        <div className={""}>
          <div className={"p-grid calendar-controls"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center"}>
              <Button label={"-14"}
                      disabled={loading}
                      className={"p-mr-2 p-button-warning"}
                      onClick={() => {
                        setSelectedDate(moment(selectedDate).subtract(14, 'days').toDate())
                        localStorage.setItem('selectedDate', moment(selectedDate).subtract(14, 'days').toDate())
                      }}/>
              <Button label={"-7"}
                      disabled={loading}
                      className={"p-mr-2 p-button-warning"}
                      onClick={() => {
                        setSelectedDate(moment(selectedDate).subtract(7, 'days').toDate())
                        localStorage.setItem('selectedDate', moment(selectedDate).subtract(7, 'days').toDate())
                      }}/>
              <Button label={"-2"}
                      disabled={loading}
                      className={"p-mr-2 p-button-warning"}
                      onClick={() => {
                        setSelectedDate(moment(selectedDate).subtract(2, 'days').toDate())
                        localStorage.setItem('selectedDate', moment(selectedDate).subtract(2, 'days').toDate())
                      }}/>
              <Button label={t('today')}
                      disabled={loading}
                      className={"p-mr-2 p-button-info"}
                      onClick={() => {
                        setSelectedDate(moment().subtract(0, 'days').toDate())
                        localStorage.setItem('selectedDate', moment().subtract(0, 'days').toDate())
                      }}/>
              <Button label={"+2"}
                      disabled={loading}
                      className={"p-mr-2 p-button-success"}
                      onClick={() => {
                        setSelectedDate(moment(selectedDate).subtract(-2, 'days').toDate())
                        localStorage.setItem('selectedDate', moment(selectedDate).subtract(-2, 'days').toDate())
                      }}/>
              <Button label={"+7"}
                      disabled={loading}
                      className={"p-mr-2 p-button-success"}
                      onClick={() => {
                        setSelectedDate(moment(selectedDate).subtract(-7, 'days').toDate())
                        localStorage.setItem('selectedDate', moment(selectedDate).subtract(-7, 'days').toDate())
                      }}/>
              <Button label={"+14"}
                      disabled={loading}
                      className={"p-mr-2 p-button-success"}
                      onClick={() => {
                        setSelectedDate(moment(selectedDate).subtract(-14, 'days').toDate())
                        localStorage.setItem('selectedDate', moment(selectedDate).subtract(-14, 'days').toDate())
                      }}/>
              <Calendar
                value={localStorage.getItem('selectedDate') ? moment(localStorage.getItem('selectedDate')).toDate() : selectedDate}
                disabled={loading}
                dateFormat={t('YY-MM-DD')}
                style={{maxWidth: '140px'}}
                locale={"default"}
                showIcon
                onChange={(e) => {
                  if (e.value !== null) {
                    setSelectedDate(e.value)
                    localStorage.setItem('selectedDate', e.value)
                  }
                }}/>
            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-right"}>
              <HelpComponent type={"site"} position={"UNDER_HELP_BUTTON"}/>
              <Button aria-label={t('sum')}
                      className={"p-ml-2 p-button-success"}
                      onClick={() => {
                        localStorage.setItem('selectedAccommodation', 'undefined')
                        window.App.setState({
                          rerenderReservationList: Math.random(),
                        })
                      }}>
                <span>&#8721;</span>
              </Button>
              <Dropdown  options={accommodations}
                        className={"p-ml-2"}
                        optionLabel="name"
                        optionValue="id"
                        id={"accommodation"}
                        emptyMessage={t('empty_message')}
                        onChange={(e) => {
                          window.App.setState({
                            rerenderReservationList: Math.random(),
                          })
                          setSelectedDate(moment().subtract(6, 'days').toDate())
                          localStorage.setItem('selectedAccommodation', e.value)
                        }}
                        value={Number(localStorage.getItem('selectedAccommodation'))}
              />
              {/*<Button label={t('bills')}*/}
              {/*        icon={"pi pi-list"}*/}
              {/*        className={"p-ml-2 p-button-warning"}*/}
              {/*        onClick={() => {*/}

              {/*        }}/>*/}
              {/*<Button label={t('groups')}*/}
              {/*        icon={"pi pi-users"}*/}
              {/*        className={"p-ml-2 p-button-success"}*/}
              {/*        onClick={() => {*/}

              {/*        }}/>*/}
              <Button label={t('reservation')}
                      icon={"pi pi-plus"}
                      className={"p-ml-2 p-button-success"}
                      onClick={() => {
                        navigate('/calendar/create');
                      }}/>
            </div>
          </div>
          <FullCalendar
            ref={calendarRef}
            initialDate={moment(selectedDate).format('YYYY-MM-DD')}
            locales={allLocales}
            locale={Cookies.get("language")}
            headerToolbar={false}
            plugins={[resourceTimelinePlugin, interactionPlugin]}
            resources={resources}
            events={events}
            schedulerLicenseKey="CC-Attribution-NonCommercial-NoDerivatives"
            views={{
              resourceTimelineXlarge: {
                type: "resourceTimeline",
                duration: {days: 15},
                slotDuration: {hours: 24},
              },
              resourceTimelineMedium: {
                type: "resourceTimeline",
                duration: {days: 7},
                slotDuration: {hours: 24},
              },
              resourceTimelineSmall: {
                type: "resourceTimeline",
                duration: {days: 2},
                slotDuration: {hours: 24},
              },
            }}
            initialView={
              screenSize === "small"
                ? "resourceTimelineSmall"
                : screenSize === "medium"
                  ? "resourceTimelineMedium"
                  : "resourceTimelineXlarge"
            }
            eventContent={(event) => {
              const isJustDropped = event.event.extendedProps.originalId === lastDroppedId;
              const reservation = event.event._def.extendedProps?.reservation || {};
              const associationCode = typeof reservation?.association_code === 'string'
                ? reservation.association_code.split('|').pop().trim().substring(0)
                : '';
              let errors = false
              if (event.event._def.extendedProps.errors > 0) {
                errors = true
              }
              if (event.event._def.extendedProps && event.event._def.extendedProps && event.event._def.extendedProps.status && event.event._def.extendedProps.status === 'occ') {
                const occTooltipClass = "tt-occ-calendar-info-" + String(event.event.id || event.event._def?.publicId || 'occ')
                  .replace(/[^a-zA-Z0-9_-]/g, '');
                return (
                  <div
                    className={"event occ"}>
                    <span
                      style={{display: 'inline-flex', alignItems: 'center', whiteSpace: 'nowrap', flexWrap: 'nowrap'}}>
                      <span className={occTooltipClass + " p-mr-2"} data-pr-tooltip={t('capacity_free_places')}>
                        <i className={"pi pi-info-circle"}
                           style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                      </span>
                      <span className={"p-text-nowrap"}>{event.event._def.title}</span>
                    </span>
                    <Tooltip target={"." + occTooltipClass}/>
                  </div>
                )
              } else {
                let moved = ''
                if (event.event._def.extendedProps.reservationId.includes('/C') || event.event._def.extendedProps.reservationId.includes('/B')) {
                  moved = 'moved'
                }
                const _hasBeds = Number(event.event._def.extendedProps.status.match(/\d+/)?.[0] || 0)
                let _height = '36px'
                let _heightM = 36
                if (event.event._def.extendedProps.tooltip === false) {
                  _heightM = 35.5
                }
                if (_hasBeds > 0 && isJustDropped === false) {
                  _height = (_heightM * _hasBeds) + _heightM + (_hasBeds * 1) + 'px'
                }
                let showContacts = false
                let showContactsBlocked = false
                const hasAtLeastTwoDaysBetween = (reservedFrom, reservedTo) => {
                  const from = moment(reservedFrom);
                  const to = moment(reservedTo);
                  if (!from.isValid() || !to.isValid()) return false;
                  return to.diff(from, "hours", true) >= 48;
                };
                const from = reservation?.reserved_from;
                const to = reservation?.reserved_to;
                const showContactsByDuration = hasAtLeastTwoDaysBetween(from, to);
                showContacts = showContactsByDuration;
                showContactsBlocked = _hasBeds >= 2
                const showDetailsBlocked = showContactsBlocked && showContactsByDuration === false
                const reservationGroupId = reservation?.reservation_group?.id;
                const reservationGroupColor = reservationGroupId
                  ? "#" + window.App.generateHexFromNumber(reservationGroupId)
                  : null;
                if (showContactsBlocked) {
                  showContacts = true
                }
                return (
                  <div
                    style={{
                      height: _height,
                      position: "relative",
                      zIndex: 9,
                      borderBottom: reservationGroupColor ? `5px solid ${reservationGroupColor}` : undefined
                    }}
                    className={"event " + event.event._def.extendedProps.status + " " + " event-just-dropped-" + isJustDropped + " "
                      + event.event._def.extendedProps?.currentResource?.type + " " + "tooltip-"
                      + event.event._def.extendedProps.reservationId.replace('/', '') + " partly-" + event.event._def.extendedProps.partly
                      + " errors-" + errors + " source-" + event.event._def?.extendedProps?.source?.toLowerCase() + " channel-"
                      + event.event._def?.extendedProps?.channel?.toLowerCase().replaceAll(' ', '')}>
                    <span
                      className={"p-badge drag-handle " + event.event._def.extendedProps.billingStatus + " " + moved}>
                      {event.event._def.extendedProps.reservationId.includes('/C') &&
                        <i className="pi pi-sign-out p-mr-2"></i>
                      }
                      {associationCode || event.event._def.title}
                      {event.event._def.extendedProps.reservationId.includes('/B') &&
                        <i className="pi pi-sign-in p-ml-2"></i>
                      }
                    </span>
                    {showContacts &&
                      <>
                        {event.event._def.extendedProps.tooltip !== false &&
                          <span className={"details block-" + showDetailsBlocked}>
                            {/*{event.event._def.extendedProps?.reservation?.customers?.length > 9 ? (*/}
                            {/*  <>9+/{event.event._def.extendedProps?.reservation?.number_of_guests || '0'}</>*/}
                            {/*) : (*/}
                            {/*  <>*/}
                            {event.event._def.extendedProps?.numberOfGuests || '0'}/{event.event._def.extendedProps?.reservation?.number_of_guests || '0'}
                            {/*</>*/}
                            {/*)}*/}
                          </span>
                        }
                      </>
                    }
                    {showContacts &&
                      <>
                        {event.event._def.extendedProps.tooltip === false &&
                          <span className={"details block-" + showDetailsBlocked}>
                            {event.event._def.title}
                          </span>
                        }
                      </>
                    }
                    {showContacts &&
                      <span className={"contacts block-" + showContactsBlocked}>
                        {event.event._def.extendedProps.contact &&
                          <>
                            {event.event._def.extendedProps.contact}
                          </>
                        }
                      </span>
                    }
                    {event.event._def.extendedProps.tooltip !== false &&
                      <Tooltip target={".tooltip-" + event.event._def.extendedProps.reservationId.replace('/', '')}>
                        <div className={"tooltip"} style={{whiteSpace: "nowrap"}}>
                          {event.event._def.extendedProps.contact ? (
                            <span className={"p-d-block"}>
                            <i className={"pi pi-info-circle p-mr-2"}></i>{event.event._def.extendedProps.contact}
                          </span>
                          ) : (
                            <span className={"p-d-block"}>
                            {t('no_contact')}
                          </span>
                          )}
                          {event.event._def.extendedProps?.original?.reservation?.customers && event.event._def.extendedProps?.original?.reservation?.customers[0] &&
                            <>
                              <hr/>
                              {event.event._def.extendedProps.reservation.customers.map((customer, index) => {
                                return (
                                  <>
                                  <span className={"p-d-block"}>
                                    <i className={"pi pi-users p-mr-2"}></i>{customer.firstname} {customer.lastname}
                                  </span>
                                  </>
                                )
                              })}
                            </>
                          }
                        </div>
                      </Tooltip>
                    }
                  </div>
                )
              }
            }}
            resourceLabelContent={(resource) => {
              return (
                <div style={{paddingLeft: `${resource?.resource?._resource?.extendedProps?.level * 15}px`}}>
                  {/*{resource?.resource?._resource?.id}*/}
                  {resource?.resource?._resource?.extendedProps?.type === 'unit' &&
                    <>
                      {resource?.resource?._resource?.extendedProps?.clean === true ? (
                        <CleaningBroomIcon className={"p-mr-2"}
                                           style={{
                                             position: "relative",
                                             top: "2px",
                                             cursor: "pointer",
                                             color: "#689f38",
                                           }}
                                           onClick={() => {
                                             axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "residential-unit/"
                                               + resource?.resource?._resource?.extendedProps?.originalId,
                                               {
                                                 clean: false,
                                               },
                                               {
                                                 params: {},
                                                 headers: {
                                                   'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                   "Sys-name": Cookies.get("instanceId"),
                                                   "Preferred-locale": Cookies.get("language")
                                                 }
                                               })
                                               .then(response => {
                                                 window.App.setState({rerenderReservationList: Math.random()})
                                               })
                                               .catch(error => {

                                               })
                                           }}
                        />
                      ) : (
                        <CleaningBroomIcon className={"p-mr-2"}
                                           style={{
                                             position: "relative",
                                             top: "2px",
                                             cursor: "pointer",
                                             color: "#d32f2f",
                                           }}
                                           onClick={() => {
                                             axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "residential-unit/"
                                               + resource?.resource?._resource?.extendedProps?.originalId,
                                               {
                                                 clean: true,
                                               },
                                               {
                                                 params: {},
                                                 headers: {
                                                   'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                   "Sys-name": Cookies.get("instanceId"),
                                                   "Preferred-locale": Cookies.get("language")
                                                 }
                                               })
                                               .then(response => {
                                                 window.App.setState({rerenderReservationList: Math.random()})
                                               })
                                               .catch(error => {

                                               })
                                           }}
                        />
                      )}
                    </>
                  }
                  {resource?.resource?._resource?.extendedProps?.type === 'bed' &&
                    <i className={"pi pi-inbox p-mr-2 p-ml-3"}></i>
                  }
                  {resource?.resource?._resource?.extendedProps?.label}
                </div>
              );
            }}
            resourceAreaWidth={'220px'}
            resourceAreaHeaderContent={() => {
              return (
                <>&nbsp;</>
              )
            }}
            height={'auto'}
            width={'auto'}
            expandRows={false}
            slotLabelContent={(day) => {
              if (day.level === 0) {
                return (
                  <div
                    className={"day p-text-center " + moment.utc(day.date).local().format('ddd').toLowerCase() + " is-active-" + day.isActive}
                    data-today={moment.utc(day.date).local().format('YYYY-MM-DD') == moment.utc(new Date(Date.now())).local().format('YYYY-MM-DD')}
                    data-selected={moment.utc(day.date).local().format('YYYY-MM-DD') == moment.utc(selectedDate).local().format('YYYY-MM-DD')}>
                  <span className={"p-d-block"}>
                    {moment.utc(day.date).local().format('DD')}
                  </span>
                    <span className={"p-d-block"}>
                    {t(moment.utc(day.date).local().format('ddd').toLowerCase())}
                  </span>
                    <span className={"p-d-block"}>
                    {moment.utc(day.date).local().format('YY')}
                      &nbsp;
                      {t(moment.utc(day.date).local().format('MMM').toLowerCase())}
                  </span>
                  </div>
                )
              } else {
                return false
              }
            }}
            eventClick={(event) => {
              if (event.event._def.extendedProps.tooltip !== false) {
                setIsEventClicked(true);
                setTimeout(() => setIsEventClicked(false), 100);
                navigate('/calendar/read/' + event.event._def.extendedProps.originalId);
              }
            }}
            dateClick={(date) => {
              const mouseUpEvent = lastMouseUpEventRef.current;
              const isOooClick = Boolean(mouseUpEvent?.target?.closest?.('.ooo'));
              if (isEventClicked || screenSize === "small" || screenSize === "medium" || isOooClick) {
                return;
              }
              if (date && date.resource && date.resource._resource.extendedProps.type !== 'category') {
                navigate('/calendar/createbyresource');
                window.App.setState({
                  propsReservation: {
                    resource: date.resource._resource.extendedProps.type.charAt(0).toUpperCase() + "-" + date.resource._resource.extendedProps.originalId,
                    date: date.date,
                    reserved_to: null,
                  },
                })
              } else {
                window.App.toastShow('warn', t('warning'), t('category_reservation_not_allowed'));
              }
            }}
            editable={true}
            resourceEditable={true}
            eventDurationEditable={false}
            eventOverlap={true}
            eventDragStart={(info) => {
              setLastDroppedId(info?.event?._def?.extendedProps?.originalId);
              const isHandle = info.jsEvent.target.classList.contains('p-badge') ||
                info.jsEvent.target.closest('.p-badge');
              if (!isHandle) {

              }
            }}
            eventDrop={(info) => {
              setEvent(info)
              window.App.setState({confirmCalendarDnd: true})
            }}
          />
          <ConfirmDialog group="declarative" visible={window.App.state.confirmCalendarDnd}
                         onHide={() => {
                           window.App.setState({confirmLogout: false})
                         }}
                         closable={false}
                         acceptLabel={t('yes')} rejectLabel={t('no')}
                         message={t('confirm_event_patch_message')} header={t('confirm_event_patch')}
                         icon="pi pi-exclamation-triangle"
                         accept={() => {
                           patchEvent(event);
                         }}
                         reject={() => {
                           let dateFrom = moment(selectedDate).add(-1, "days").format("YYYY-MM-DD");
                           let dateTo = moment(selectedDate).add(22, "days").format("YYYY-MM-DD");
                           buildCalendar(dateFrom, dateTo);
                           window.App.setState({confirmCalendarDnd: false})
                         }}/>
          <div className={"p-grid p-mt-3"} style={{maxWidth: '1180px', marginLeft: 'auto', marginRight: 'auto'}}>
            <div className={"p-col p-col-align-center p-text-center"}>
              <div className={"event pending"} style={{cursor: 'default'}}>
                {t('pending')}
              </div>
            </div>
            <div className={"p-col p-col-align-center p-text-center"}>
              <div className={"event confirmed"} style={{cursor: 'default'}}>
                {t('reserved')}
              </div>
            </div>
            <div className={"p-col p-col-align-center p-text-center"}>
              <div className={"event checked_in"} style={{cursor: 'default'}}>
                {t('checked_in')}
              </div>
            </div>
            <div className={"p-col p-col-align-center p-text-center"}>
              <div className={"event checked_out"} style={{cursor: 'default'}}>
                {t('checked_out')}
              </div>
            </div>
            <div className={"p-col p-col-align-center p-text-center"}>
              <div className={"event no_show"} style={{cursor: 'default'}}>
                {t('no_show')}
              </div>
            </div>
            <div className={"p-col p-col-align-center p-text-center"}>
              <div className={"event cancelled"} style={{cursor: 'default'}}>
                {t('cancelled')}
              </div>
            </div>
            <div className={"p-col p-col-align-center p-text-center"}>
              <div className={"event relocated"} style={{color: '#ffffff', cursor: 'default'}}>
                {t('relocated')}
              </div>
            </div>
            <div className={"p-col p-col-align-center p-text-center"}>
              <div className={"event errors-true"} style={{color: '#ffffff', cursor: 'default'}}>
                {t('error')}
              </div>
            </div>
          </div>
          <div className={"p-grid p-mt-0"} style={{maxWidth: '1180px', marginLeft: 'auto', marginRight: 'auto'}}>
            <div className={"p-col p-col-align-center p-text-center"}>
              <div className={"event source-external"} style={{cursor: 'default', border: '1px solid #ccc'}}>
                {t('event_source_external')}
              </div>
            </div>
            <div className={"p-col p-col-align-center p-text-center"}>
              <div className={"event channel-direct"} style={{cursor: 'default', border: '1px solid #ccc'}}>
                {t('event_channel_direct')}
              </div>
            </div>
            <div className={"p-col p-col-align-center p-text-center"}>
              <div className={"event channel-directonline"} style={{cursor: 'default', border: '1px solid #ccc'}}>
                {t('event_channel_directonline')}
              </div>
            </div>
            <div className={"p-col p-col-align-center p-text-center"}>
              <div className={"event channel-indirect"} style={{cursor: 'default', border: '1px solid #ccc'}}>
                {t('event_channel_indirect')}
              </div>
            </div>
            <div className={"p-col p-col-align-center p-text-center"}>
              <div className={"event channel-indirectonline"} style={{cursor: 'default', border: '1px solid #ccc'}}>
                {t('event_channel_indirectonline')}
              </div>
            </div>


          </div>
        </div>
        <Sidebar position="right" visible={action === 'create'} closeOnEscape={true}
                 style={{width: '780px'}}
                 onHide={() => {
                   navigate('/calendar');
                 }}>
          <_FM_ReservationFormComponent/>
        </Sidebar>
        <Sidebar position="right" visible={action === 'update'} closeOnEscape={true}
                 style={{width: '99%'}}
                 onHide={() => {
                   navigate('/calendar');
                 }}>
          <_FM_ReservationFormComponent/>
        </Sidebar>
        <Sidebar position="right" visible={action === 'createbyresource'} closeOnEscape={true}
                 style={{width: '780px'}}
                 onHide={() => {
                   navigate('/calendar');
                 }}>
          <_FM_ReservationResourceFormComponent/>
        </Sidebar>
        <Sidebar position="right" visible={action === 'read' && id} closeOnEscape={true}
                 style={{width: '99%'}}
                 onHide={() => {
                   navigate('/calendar');
                 }}>
          <_FM_ReservationShowComponent/>
        </Sidebar>
        <Sidebar position="right" visible={window.App.urlVars().manage === 'relocate'} closeOnEscape={true}
                 style={{width: '99%'}}
                 onHide={() => {
                   navigate(-1);
                 }}>
          <_FM_ReservationRelocateFormComponent reservationId={id}/>
        </Sidebar>
        <Dialog visible={window.App.urlVars().read === 'folio'}
                header={t('customer_folio')}
                footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info"
                                                 text={t("dialog_movable")}/></React.Fragment>}
                onHide={() => {
                  navigate('/calendar/' + action + '/' + id);
                }}
                modal={false}
                style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
          <_FM_FolioShowComponent reservationId={id}/>
        </Dialog>
        <Dialog visible={window.App.urlVars().update === 'folio' || window.App.urlVars().create === 'folio'}
                footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info"
                                                 text={t("dialog_movable")}/></React.Fragment>}
                header={t('customer_folio')}
                onHide={() => {
                  navigate(-1);
                }}
                modal={false}
                style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
          <_FM_FolioFormComponent reservationId={id}/>
        </Dialog>
        <Dialog visible={window.App.urlVars().manage === 'folio'}
                header={t('customer_folio')}
                onHide={() => {
                  navigate('/calendar/' + action + '/' + id);
                }}
                modal={false}
                draggable={false}
                style={{width: '99%'}}>
          <_FM_FolioDndComponent/>
        </Dialog>
        <Dialog header={t('new_receipt')}
                visible={window.App.urlVars().create === 'invoice' || window.App.urlVars().update === 'invoice'}
                style={{width: '99%'}}
                onHide={() => {
                  navigate(-1)
                }} modal={false} draggable={false}>
          <_FM_ReceiptFormComponent/>
        </Dialog>
        <Dialog header={t('new_receipt')} visible={window.App.urlVars().read === 'invoice'}
                style={{width: '99%'}}
                onHide={() => {
                  navigate(-1)
                }} modal={false} draggable={false}>
          <_FM_ReceiptShowComponent/>
        </Dialog>

      </div>
    </>
  )
}
export default withTranslation('common')(_FM_CalendarPage);
